<!--
  File name: StatusChip.vue
  Program Description:
    - This component displays the custom chip used for DBN Status and Analytics Status.
-->
<template>
  <v-chip
    :class="chipColor"
    :outlined="isChipOutlined"
  >
    <span :class="chipTextColor">
      {{ statusLabel }}
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'StatusChip',
  props: {
    status: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    chipColor () {
      if (!this.isActive) return 'status_closed lighten-1'
      const colors = {
        Drafted: 'blue lighten-5',
        Submitted: 'green lighten-5',
        'For Evaluation': 'yellow lighten-4',
        'Initial Review': 'status_pdbnf_review',
        'Final Review': 'status_pdbnf_review lighten-5',
        'Initial Order': 'status_initial_order lighten-5',
        'For Evaluation - PBNEF': 'yellow lighten-4',
        'Initial Review - PBNEF': 'orange darken-4',
        'Final Review - PBNEF': 'orange lighten-5',
        'For Approval - PBNEF': 'orange lighten-5',
        'Show Cause Order': 'status_show_cause lighten-2',
        'For Evaluation - FBNER': 'yellow lighten-4',
        'Initial Review - FBNER': 'status_fbner_review',
        'Final Review - FBNER': 'status_fbner_review lighten-3',
        'For Adjudication': 'green lighten-5',
        'For Investigation': 'status_investigation lighten-4',
        'For Enforcement': 'orange lighten-5',
        Closed: 'status_closed lighten-5',
        Approved: 'green darken-2',
        Pending: 'grey lighten-2'
      }
      return colors[`${this.status}`]
    },
    chipTextColor () {
      if (!this.isActive) return 'white--text'
      const textColor = {
        Drafted: 'blue--text text--darken-1',
        Submitted: 'green--text text--darken-1',
        'For Evaluation': 'yellow--text text--darken-4',
        'Initial Review': 'status_pdbnf_review--text text--darken-1',
        'Final Review': 'status_pdbnf_review--text text--darken-1',
        'Initial Order': 'status_initial_order--text text--darken-1',
        'For Evaluation - PBNEF': 'yellow--text text--darken-4',
        'Initial Review - PBNEF': 'orange--text text--darken-4',
        'Final Review - PBNEF': 'orange--text text--darken-4',
        'For Approval - PBNEF': 'orange--text text--darken-4',
        'Show Cause Order': 'black--text',
        'For Evaluation - FBNER': 'yellow--text text--darken-4',
        'Initial Review - FBNER': 'status_fbner_review--text text--darken-1',
        'Final Review - FBNER': 'status_fbner_review--text text--darken-1',
        'For Adjudication': 'green--text text--darken-1',
        'For Investigation': 'status_investigation--text text--lighten-1',
        'For Enforcement': 'orange--text text--darken-5',
        Closed: 'status_closed--text text--darken-1',
        Approved: 'white--text',
        Pending: 'grey--text'
      }
      return textColor[`${this.status}`]
    },
    isChipOutlined () {
      if (!this.isActive) return false
      const outlined = [
        'Initial Review',
        'Initial Review - PBNEF',
        'Initial Review - FBNER',
        'Pending'
      ]
      return outlined.includes(this.status)
    },
    statusLabel () {
      return this.isActive ? this.label || this.status : 'Invalid'
    }
  }
}
</script>
